import React, { useState, useMemo } from "react";
import data from "./data.json";


const COLORS = {
    bg: "#e7eef8",
    panel: "#d7e3f3",
    accent: "#bfcee8",
    inputBg: "#fffdf7",
    greenBox: "#d7f3dc",
    headerText: "#0b4a86"
};

const defaultEntry = { entryNo: "", description: "", weight: "", rate: "" };

export default function TraderSaleEntry() {
    const { header, form, boxes, tables, buttons, saleTypes, rightSection } = data;

    // Form fields
    const [billNo, setBillNo] = useState("");
    const [date, setDate] = useState("");
    const [partyName, setPartyName] = useState("");
    const [itemName, setItemName] = useState("");
    const [marketCess, setMarketCess] = useState(0);
    const [items, setItems] = useState([{ box: "", qnt: "" }]);
    const [form1, setForm1] = useState({ upaar: "", jama: "", baki: "" });
    const [form2, setForm2] = useState({ upaar: "", jama: "", baki: "" });
    const [boxData, setBoxData] = useState([{ name: "", qnt: "" }]);
    const [entry1, setEntry1] = useState([{ entryNo: "", vigat: "", vajan: "", rate: "", amt: "" }]);
    const [entry2, setEntry2] = useState([{ entryNo: "", item: "", vajan: "", rate: "", amt: "" }]);
    const [bills, setBills] = useState([{ billNo: "", partyName: "", amt: "" }]);

    const addRow = () => {
        setItems([...items, { box: "", qnt: "" }]);
    };

    const total = items.reduce(
        (acc, curr) => acc + (parseFloat(curr.qnt) || 0),
        0
    );

    const calcTotal = (data, field) =>
        data.reduce((acc, curr) => acc + (parseFloat(curr[field]) || 0), 0);

    const [boxName, setBoxName] = useState("");
    const [boxQnt, setBoxQnt] = useState("");
    const [boxesList, setBoxesList] = useState([]);

    const [entries, setEntries] = useState([]);
    const [entryForm, setEntryForm] = useState(defaultEntry);

    const [billSummary, setBillSummary] = useState([]);

    function addBox() {
        if (!boxName) return;
        const q = Number(boxQnt) || 0;
        setBoxesList((s) => [...s, { id: Date.now(), name: boxName, qnt: q }]);
        setBoxName("");
        setBoxQnt("");
    }

    function removeBox(id) {
        setBoxesList((s) => s.filter((b) => b.id !== id));
    }

    function addEntry() {
        const { entryNo, description, weight, rate } = entryForm;
        if (!entryNo && !description) return;
        const w = Number(weight) || 0;
        const r = Number(rate) || 0;
        const amt = Number((w * r).toFixed(2));
        setEntries((s) => [...s, { id: Date.now(), entryNo, description, weight: w, rate: r, amt }]);
        setEntryForm(defaultEntry);
    }

    function removeEntry(id) {
        setEntries((s) => s.filter((e) => e.id !== id));
    }

    const totalBoxQnt = useMemo(() => boxesList.reduce((p, c) => p + (Number(c.qnt) || 0), 0), [boxesList]);
    const totalEntriesAmt = useMemo(() => entries.reduce((p, c) => p + (Number(c.amt) || 0), 0), [entries]);
    const totalEntriesWeight = useMemo(() => entries.reduce((p, c) => p + (Number(c.weight) || 0), 0), [entries]);

    function saveEntry() {
        const amt = Number(totalEntriesAmt.toFixed(2));
        setBillSummary((s) => [
            ...s,
            { id: Date.now(), billNo: billNo || `B${Date.now().toString().slice(-4)}`, party: partyName || "Unknown", amt }
        ]);

    }

    function formatNumberInput(v) {
        if (v === "") return "";
        const n = Number(v);
        if (Number.isNaN(n)) return "";
        return n;
    }

    const { fields } = data.form2;
    const [formData, setFormData] = useState({});

    const handleChange = (label, value) => {
        setFormData({ ...formData, [label]: value });
    };

    return (
        <div className="w-full min-h-screen flex flex-col"
        // style={{ background: COLORS.bg, border: "1px solid rgba(0,0,0,0.08)" }}
        >
            {/* Top header band */}
            <div className="flex flex-col sm:flex-row items-center justify-between px-4 py-2 gap-2" style={{ background: COLORS.panel }}>
                <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4 text-center sm:text-left">
                    <div className="text-lg sm:text-xl font-bold" style={{ color: COLORS.headerText }}>
                        {header.title}
                    </div>
                    <div className="text-xs sm:text-sm text-gray-600">{header.subtitle}</div>
                </div>
                <div className="text-xs sm:text-sm text-gray-600 text-center sm:text-right">{header.softwareInfo}</div>
            </div>

            {/* main content area */}
            <div className="flex flex-col lg:flex-row px-2 sm:px-3 py-2 gap-3 overflow-x-auto">
                {/* Left column: main form (cols 1-4) */}
                <div className="w-full lg:w-1/4 bg-slate-700 rounded-md">
                    <div className="py-2 px-2 rounded-md flex flex-col gap-2 bg-[#dbe6f3]">
                        <div className="flex flex-col gap-2 w-full sm:w-72">

                            <div className="flex sm:flex-row sm:justify-between sm:items-center gap-1">
                                <label className="text-sm font-medium w-full">{form.billNumber}</label>
                                <input
                                    className="border px-2 py-1 rounded-sm text-sm w-full sm:w-auto"
                                    value={billNo}
                                    onChange={(e) => setBillNo(e.target.value)}
                                    placeholder="Bill No"
                                />
                            </div>
                            <div className="flex sm:flex-row sm:justify-between sm:items-center gap-1">
                                <label className="text-sm font-medium w-full">{form.date}</label>
                                <input
                                    type="date"
                                    className="border px-2 py-1 rounded-sm text-sm w-full sm:w-auto"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                />
                            </div>
                            <div className="flex  sm:flex-row sm:justify-between sm:items-center gap-1">
                                <label className="text-sm font-medium w-full" >{form.day}</label>
                                <input className="border px-2 py-1 rounded-sm text-sm w-full sm:w-auto" placeholder="Day" />
                            </div>
                            <div className="flex  sm:flex-row sm:justify-between sm:items-center gap-1">
                                <label className="text-sm font-medium w-full">{form.partyCode}</label>
                                <input
                                    className="border px-2 py-1 rounded-sm text-sm w-full sm:w-auto"
                                    value={partyName}
                                    onChange={(e) => setPartyName(e.target.value)}
                                    placeholder="Party Name"
                                />
                            </div>
                            <div className="flex sm:flex-row sm:justify-between sm:items-center gap-1">
                                <label className="text-sm font-medium w-full">{form.itemCode}</label>
                                <input
                                    className="border px-2 py-1 rounded-sm text-sm w-full sm:w-auto"
                                    value={itemName}
                                    onChange={(e) => setItemName(e.target.value)}
                                    placeholder="Item Name"
                                />
                            </div>

                        </div>


                        <div className="border-gray-950 border-t pt-3">
                            <form className="flex flex-col gap-2">
                                {/* Sales Type */}
                                <div className="flex sm:flex-row sm:items-center sm:justify-between gap-2">
                                    <label className="text-sm font-semibold text-gray-800 w-full">
                                        {fields[0].label} :
                                    </label>
                                    <select
                                        className="col-span-3 border border-gray-400 rounded-sm px-2 py-1 text-sm bg-white focus:outline-none"
                                        onChange={(e) => handleChange(fields[0].label, e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        {fields[0].options.map((opt, i) => (
                                            <option key={i} value={opt}>
                                                {opt}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Next Fields */}
                                <div className="flex gap-4 items-center justify-between">
                                    <label className="text-sm font-semibold text-gray-800 text-nowrap">
                                        {fields[1].label} :
                                    </label>
                                    <div className="flex gap-1">
                                        <input
                                            type="text"
                                            className="w-20 border border-gray-400 rounded-sm py-1 text-sm focus:outline-none"
                                            onChange={(e) => handleChange(fields[1].label, e.target.value)}
                                        />
                                        <input
                                            type="text"
                                            className="w-20 border border-gray-400 rounded-sm py-1 text-sm focus:outline-none"
                                            onChange={(e) => handleChange("Crate/Count 2", e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                                    <label className="text-sm font-semibold text-gray-800">
                                    </label>
                                    <input
                                        type="text"
                                        className="border border-gray-400 rounded-sm px-2 py-1 text-sm focus:outline-none w-full sm:w-auto"
                                        onChange={(e) => handleChange(fields[3].label, e.target.value)}
                                    />
                                </div>


                                {/* Second input same row */}

                                {/* Rate/Commission */}
                                <div className="flex gap-2 items-center justify-between">
                                    <label className="text-sm font-semibold text-gray-800 text-nowrap">
                                        {fields[3].label} :
                                    </label>
                                    <div className="flex gap-1">
                                        <input
                                            type="text"
                                            className="w-20 border border-gray-400 rounded-sm py-1 text-sm focus:outline-none"
                                            onChange={(e) => handleChange(fields[1].label, e.target.value)}
                                        />
                                        <input
                                            type="text"
                                            className="w-20 border border-gray-400 rounded-sm py-1 text-sm focus:outline-none"
                                            onChange={(e) => handleChange("Crate/Count 2", e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* Sauda */}
                                <div className="flex gap-4 items-center justify-between">

                                    <label className="text-sm font-semibold text-gray-800">
                                        {fields[5].label} :
                                    </label>
                                    <input
                                        type="text"
                                        className="col-span-3 border border-gray-400 rounded-sm px-2 py-1 text-sm focus:outline-none"
                                        onChange={(e) => handleChange(fields[5].label, e.target.value)}
                                    />
                                </div>

                                {/* Commission Charges */}
                                <div className="flex gap-2 items-center justify-between">

                                    <label className="text-sm font-semibold text-gray-800">
                                        {fields[6].label} :
                                    </label>
                                    <input
                                        type="number"
                                        className="col-span-3 border border-gray-400 rounded-sm px-2 py-1 text-sm bg-gray-50 text-right"
                                        defaultValue="0.00"
                                        readOnly
                                    />
                                </div>
                                {/* Union and Bhada */}
                                <div className="flex gap-4 items-center justify-between">

                                    <label className="text-sm font-semibold text-gray-800 ">
                                        {fields[7].label} :
                                    </label>
                                    <input
                                        type="number"
                                        className="border border-gray-400 rounded-sm px-2 py-1 text-sm bg-gray-50 text-right"
                                        defaultValue="0.00"
                                        readOnly
                                    />
                                </div>
                                <div className="flex gap-4 items-center justify-between">

                                    <label className="text-sm font-semibold text-gray-800 ">
                                        Bhada Charges :
                                    </label>
                                    <input
                                        type="number"
                                        className="border border-gray-400 rounded-sm px-2 py-1 text-sm bg-gray-50 text-right"
                                        defaultValue="0.00"
                                        readOnly
                                    />
                                </div>
                                {/* Total */}
                                <div className="flex gap-4 items-center justify-between">

                                    <label className="text-sm font-semibold text-gray-800">
                                        {fields[9].label} :
                                    </label>
                                    <input
                                        type="number"
                                        className="col-span-3 border border-gray-400 rounded-sm px-2 py-1 text-sm bg-gray-50 text-right"
                                        defaultValue="0.00"
                                        readOnly
                                    />
                                </div>
                                {/* Sales Note */}
                                <div className="flex gap-4 items-center justify-between">

                                    <label className="text-sm font-semibold text-gray-800 ">
                                        {fields[10].label} :
                                    </label>
                                    <div className="flex gap-1">
                                        <input
                                            type="text"
                                            className="w-20 border border-gray-400 rounded-sm py-1 text-sm focus:outline-none"
                                            onChange={(e) => handleChange(fields[1].label, e.target.value)}
                                        />
                                        <input
                                            type="number"
                                            className="border border-gray-400 rounded-sm px-2 py-1 text-sm bg-gray-50 text-right w-auto"
                                            defaultValue="0.00"
                                            readOnly
                                        />
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>

                {/* Center column (boxes + entry list) cols 5-8 */}
                <div className="flex-1 flex flex-col gap-3">
                    <div className="col-span-12 lg:col-span-5">
                        {/* Boxes panel (top-left of center) */}
                        <div className="flex bg-[#dbe6f3] flex-col sm:flex-row">
                            <div className="flex flex-col gap-2 p-2 ">
                                <div className="flex gap-2">
                                    <div className="text-sm font-semibold">{boxes.title}:</div>
                                    <select
                                        className="col-span-3 border border-gray-400 rounded-sm px-2 py-1 text-sm bg-white focus:outline-none"
                                        onChange={(e) => handleChange(fields[0].label, e.target.value)}
                                    >
                                        <option value="">Select Item</option>
                                        <option value="Apples">Apples</option>
                                        <option value="Bananas">Bananas</option>
                                        <option value="Tomatoes">Tomatoes</option>
                                        <option value="Potatoes">Potatoes</option>
                                        <option value="Onions">Onions</option>
                                        <option value="Cabbage">Cabbage</option>
                                        <option value="Carrots">Carrots</option>
                                        <option value="Cucumbers">Cucumbers</option>
                                        <option value="Spinach">Spinach</option>
                                        <option value="Mangoes">Mangoes</option>
                                    </select>

                                    <input
                                        className="border w-16 px-2 py-1 rounded-sm text-sm"
                                    />
                                </div>

                                <div className="flex gap-2">
                                    <div className="text-sm font-semibold">Party Name:</div>
                                    <input
                                        className="border px-2 py-1 rounded-sm text-sm w-full sm:w-auto"
                                    />
                                </div>
                                <div className="flex flex-col items-center justify-center mt-5 border-t border-white">
                                    <div className="text-sm font-semibold ">Market Cess:</div>
                                    <input
                                        className="border px-2 py-1 rounded-sm text-sm w-full sm:w-auto"
                                    />
                                </div>
                            </div>

                            <div className="w-24 border border-blue-300 text-blue-900 text-center py-2 rounded-sm shadow-sm">
                                <div className="py-1">1</div>
                                <div className="py-1">2</div>
                                <div className="py-1">3</div>
                                <div className="py-1">4</div>
                                <div className="py-1">5</div>
                                <div className="py-1">6</div>
                                <div className="pt-2 font-semibold text-sm">0.00</div>
                            </div>

                            <div className="flex flex-col md:flex-row gap-4  p-3 border border-blue-300 rounded-md shadow-sm w-fit">
                                {/* Left Side */}
                                <div className=" text-sm text-blue-900 flex gap-2">
                                    {/* Form 1 */}
                                    <div className="border border-blue-200 p-2 rounded-md  shadow-sm">
                                        <h3 className="text-center font-semibold text-gray-800">(Form 1)</h3>
                                        <div className="mt-2 space-y-1">
                                            <div className="flex justify-between items-center gap-2">
                                                <label>Upaar :</label>
                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded-sm px-2 py-1 w-24"
                                                    value={form1.upaar}
                                                    onChange={(e) =>
                                                        setForm1({ ...form1, upaar: e.target.value })
                                                    }
                                                />
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <label>Jama :</label>
                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded-sm px-2 py-1 w-24"
                                                    value={form1.jama}
                                                    onChange={(e) => setForm1({ ...form1, jama: e.target.value })}
                                                />
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <label>Baki :</label>
                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded-sm px-2 py-1 w-24"
                                                    value={form1.baki}
                                                    onChange={(e) => setForm1({ ...form1, baki: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Form 2 */}
                                    <div className="border border-blue-200 p-2 rounded-md  shadow-sm">
                                        <h3 className="text-center font-semibold text-gray-800">(Form 2)</h3>
                                        <div className="mt-2 space-y-1">
                                            <div className="flex justify-between items-center gap-2">
                                                <label>Upaar :</label>
                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded-sm px-2 py-1 w-24"
                                                    value={form2.upaar}
                                                    onChange={(e) =>
                                                        setForm2({ ...form2, upaar: e.target.value })
                                                    }
                                                />
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <label>Jama :</label>
                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded-sm px-2 py-1 w-24"
                                                    value={form2.jama}
                                                    onChange={(e) => setForm2({ ...form2, jama: e.target.value })}
                                                />
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <label>Baki :</label>
                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded-sm px-2 py-1 w-24"
                                                    value={form2.baki}
                                                    onChange={(e) => setForm2({ ...form2, baki: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Right Side */}
                                <div className="flex-1 bg-white border border-blue-200 rounded-md shadow-sm text-sm">
                                    <div className="grid grid-cols-2 border-b border-blue-200 text-center font-semibold bg-yellow-100">
                                        <div className="border-r border-blue-200 py-1">Box</div>
                                        <div className="py-1">Qnt</div>
                                    </div>

                                    {items.map((item, index) => (
                                        <div key={index} className="grid grid-cols-2 text-center">
                                            <input
                                                type="text"
                                                className="border-r border-b border-blue-100 py-1 text-center focus:outline-none"
                                                value={item.box}
                                            />
                                            <input
                                                type="number"
                                                className="border-b border-blue-100 py-1 text-center focus:outline-none"
                                                value={item.qnt}
                                            />
                                        </div>
                                    ))}

                                    <button
                                        onClick={addRow}
                                        className="w-full text-blue-700 text-xs py-1 border-t border-blue-200 hover:bg-blue-50"
                                    >
                                        + Add Row
                                    </button>

                                    <div className="grid grid-cols-2 font-semibold border-t border-blue-300">
                                        <div className="text-right pr-2 py-1">Total</div>
                                        <div className="bg-gray-300 text-right pr-2 py-1">{total}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* Right column (cols 9-12) */}
                    <div className="bg-[#dbe6f3] p-2 border border-blue-300 w-full h-full text-xs">
                        <div className="flex gap-2 flex-col md:flex-row">
                            {/* Left section */}
                            <div className="rounded-sm p-2 flex flex-col gap-2 shadow-sm border border-black">
                                <div>
                                    <label className="block font-semibold mb-1 text-blue-900">Total Today :</label>
                                    <input type="text" className="w-full border border-gray-400 rounded-sm px-2 py-1" />
                                </div>
                                <div className="flex items-center gap-2">
                                    <label className="text-blue-900 text-nowrap">Rate :</label>
                                    <input
                                        type="text"
                                        className="flex-1 border border-gray-400 rounded-sm px-2 py-1"
                                    />
                                    <button className="bg-gray-200 px-3 py-1 border border-gray-400 rounded-sm text-sm">
                                        Add
                                    </button>
                                </div>

                                {/* Box list */}
                                <div className="border flex flex-col justify-between border-black rounded-sm mt-2 h-56 bg-white">
                                    <div className="grid grid-cols-2 text-center font-semibold bg-gray-100 border-b border-blue-200">
                                        <div className="border-r border-blue-200 py-1">Box Name</div>
                                        <div className="py-1">Qnt</div>
                                    </div>

                                    {boxData.map((row, i) => (
                                        <div key={i} className="grid grid-cols-2 text-center border-b border-blue-100">
                                            <input
                                                type="text"
                                                className="border-r border-blue-100 py-1 text-center focus:outline-none"
                                                value={row.name}
                                                onChange={(e) =>
                                                    handleChange(setBoxData, boxData, i, "name", e.target.value)
                                                }
                                            />
                                            <input
                                                type="number"
                                                className="py-1 text-center focus:outline-none"
                                                value={row.qnt}
                                                onChange={(e) =>
                                                    handleChange(setBoxData, boxData, i, "qnt", e.target.value)
                                                }
                                            />
                                        </div>
                                    ))}

                                    <div className="flex w-full justify-around font-semibold">
                                        <div className="text-right pr-2 py-1">Total</div>
                                        <div className="border-l border-black pl-2 text-right pr-2 py-1">
                                            {calcTotal(boxData, "qnt")}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Middle section */}
                            <div className="col-span-6 bg-white rounded-sm p-2 shadow-sm flex flex-col gap-2 border border-black">
                                {/* Top Table */}
                                <div className="h-[50%] flex flex-col justify-between border border-black">
                                    <div className="grid grid-cols-5 text-center font-semibold bg-gray-100 border-b border-blue-200">
                                        <div className="border-r py-1">Entry No</div>
                                        <div className="border-r py-1">Vigat</div>
                                        <div className="border-r py-1">Vajan</div>
                                        <div className="border-r py-1">Rate</div>
                                        <div className="py-1">Amt</div>
                                    </div>

                                    {entry1.map((row, i) => (
                                        <div key={i} className="grid grid-cols-5 text-center border-b border-blue-100">
                                            {Object.keys(row).map((key, idx) => (
                                                <input
                                                    key={idx}
                                                    type="text"
                                                    className="border-r border-blue-100 py-1 text-center focus:outline-none"
                                                    value={row[key]}
                                                    onChange={(e) =>
                                                        handleChange(setEntry1, entry1, i, key, e.target.value)
                                                    }
                                                />
                                            ))}
                                        </div>
                                    ))}

                                    <div className="grid grid-cols-5 font-semibold border-t border-blue-300">
                                        <div className="col-span-4 text-right pr-2 py-1">Total</div>
                                        <div className="text-right pr-2 py-1">
                                            {calcTotal(entry1, "amt")}
                                        </div>
                                    </div>
                                </div>

                                {/* Bottom Table */}
                                <div className="h-[50%] flex flex-col justify-between border border-black">
                                    <div className="grid grid-cols-5 text-center font-semibold bg-gray-100 border-b border-blue-200">
                                        <div className="border-r py-1">Entry No</div>
                                        <div className="border-r py-1">Item</div>
                                        <div className="border-r py-1">Vajan</div>
                                        <div className="border-r py-1">Rate</div>
                                        <div className="py-1">Amt</div>
                                    </div>

                                    {entry2.map((row, i) => (
                                        <div key={i} className="grid grid-cols-5 text-center border-b border-blue-100">
                                            {Object.keys(row).map((key, idx) => (
                                                <input
                                                    key={idx}
                                                    type="text"
                                                    className="border-r border-blue-100 py-1 text-center focus:outline-none"
                                                    value={row[key]}
                                                    onChange={(e) =>
                                                        handleChange(setEntry2, entry2, i, key, e.target.value)
                                                    }
                                                />
                                            ))}
                                        </div>
                                    ))}

                                    <div className="grid grid-cols-5 font-semibold border-t border-blue-300">
                                        <div className="col-span-4 text-right pr-2 py-1">Total</div>
                                        <div className="bg-blue-200 text-right pr-2 py-1">
                                            {calcTotal(entry2, "amt")}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right section */}
                            <div className="col-span-3 bg-white rounded-sm p-2 shadow-sm flex flex-col justify-between border border-black">
                                <div className="grid grid-cols-3 text-center font-semibold bg-yellow-100 border-b border-blue-200">
                                    <div className="border-r py-1">Bill No</div>
                                    <div className="border-r py-1">Party Name</div>
                                    <div className="py-1">Amt</div>
                                </div>

                                {bills.map((bill, i) => (
                                    <div key={i} className="grid grid-cols-3 text-center border-b border-blue-100">
                                        {Object.keys(bill).map((key, idx) => (
                                            <input
                                                key={idx}
                                                type="text"
                                                className="border-r border-blue-100 py-1 text-center focus:outline-none"
                                                value={bill[key]}
                                                onChange={(e) =>
                                                    handleChange(setBills, bills, i, key, e.target.value)
                                                }
                                            />
                                        ))}
                                    </div>
                                ))}

                                <div className="grid grid-cols-3 font-semibold border-t border-blue-300">
                                    <div className="col-span-2 text-right pr-2 py-1">Total</div>
                                    <div className="bg-yellow-200 text-right pr-2 py-1">
                                        {calcTotal(bills, "amt")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom buttons row */}
            <div className="flex flex-wrap justify-center sm:justify-between gap-2 px-2 sm:px-4 py-2" style={{ background: COLORS.panel }}>
                <button className="px-4 py-2 rounded-md text-sm bg-teal-500 text-white hover:bg-teal-600">{buttons.save}</button>
                <button className="px-4 py-2 rounded-md text-sm bg-teal-500 text-white hover:bg-teal-600">{buttons.return}</button>
                <button className="px-4 py-2 rounded-md text-sm bg-teal-500 text-white hover:bg-teal-600">{buttons.delete}</button>
                <button className="px-4 py-2 rounded-md text-sm bg-teal-500 text-white hover:bg-teal-600">{buttons.Balance}</button>
                <button className="px-4 py-2 rounded-md text-sm bg-teal-500 text-white hover:bg-teal-600">{buttons.SalesReport}</button>
                <button className="px-4 py-2 rounded-md text-sm bg-teal-500 text-white hover:bg-teal-600">{buttons.AccountExtract}</button>
                <button className="px-4 py-2 rounded-md text-sm bg-teal-500 text-white hover:bg-teal-600">{buttons.StockReport}</button>
                <button className="px-4 py-2 rounded-md text-sm bg-teal-500 text-white hover:bg-teal-600">{buttons.EntryReport}</button>
            </div>
        </div>

    );
}